<h3 class="title configurator-title">{{ 'closet-doors-custom.closet-configuration.title' | translate }}</h3>
<div class="config-container shadow">
  <h4 class="title configurator-subtitle">
    {{ 'closet-doors-custom.closet-configuration.bay-dimensions' | translate }}
  </h4>

  <ng-casto-loader *ngIf="!heightLimits"></ng-casto-loader>

  <div class="form-row" *ngIf="heightLimits">
    <div class="form-label">
      <label for="door-height">{{ 'closet-doors-custom.closet-configuration.bay-height' | translate }}</label>
      <div class="subtitle">
        {{ 'closet-doors-custom.closet-configuration.from' | translate }} {{ heightLimits?.min }}
        {{ 'closet-doors-custom.closet-configuration.to' | translate }} {{ heightLimits?.max }} mm
      </div>
    </div>
    <div class="form-input">
      <div class="mm">
        <input
          type="number"
          [min]="heightLimits?.min"
          [max]="heightLimits?.max"
          id="door-height"
          autocorrect="off"
          spellcheck="false"
          [(ngModel)]="configuration.clientHeight"
          (change)="heightChanged()"
          [ngModelOptions]="{ standalone: true }" />
      </div>
    </div>
  </div>

  <div class="form-row" *ngIf="configuration.clientHeight && widthLimits">
    <div class="form-label">
      <label for="door-width">{{ 'closet-doors-custom.closet-configuration.bay-width' | translate }}</label>
      <div class="subtitle">
        {{ 'closet-doors-custom.closet-configuration.from' | translate }} {{ widthLimits?.min }}
        {{ 'closet-doors-custom.closet-configuration.to' | translate }} {{ widthLimits?.max }} mm
      </div>
    </div>
    <div class="form-input">
      <div class="mm">
        <input
          type="number"
          [min]="widthLimits?.min"
          [max]="widthLimits?.max"
          id="door-width"
          autocorrect="off"
          spellcheck="false"
          [(ngModel)]="configuration.clientWidth"
          (change)="widthChanged()"
          [ngModelOptions]="{ standalone: true }" />
      </div>
    </div>
  </div>
</div>

<br />

<div class="config-container shadow" *ngIf="areDimensionsValid()">
  <h4 class="title configurator-subtitle">
    {{ 'closet-doors-custom.closet-configuration.opening-system' | translate }}
  </h4>

  <div class="configurator-cards-container">
    <div
      class="configurator-card"
      [ngClass]="{ active: isOpeningSelected(opening.id) }"
      *ngFor="let opening of openingSystems"
      (click)="selectOpeningSystem(opening)">
      <ng-casto-img-loader [imgSrc]="baseImgURL + opening.icon.path" [imgClass]="'opening-img'"></ng-casto-img-loader>
      <p class="configurator-card-title">{{ opening.name }}</p>
    </div>
    <ng-casto-loader *ngIf="!openingSystems"></ng-casto-loader>
  </div>

  <div
    class="opening-info"
    [ngClass]="{
      'd-none': !isOpeningSelected(opening.id),
    }"
    id="opening-info-{{ opening.id }}"
    *ngFor="let opening of openingSystems">
    <div class="opening-info-icon">
      <svg>
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-zoom"></use>
      </svg>
    </div>

    <div class="opening-info-container">
      <h6 class="opening-info-title" *ngIf="currentLang === 'fr'">
        <i
          ><strong class="more-infos">{{ 'decking-boards.environment.most-infos' | translate }}</strong> -
          <strong>{{ opening.tooltip.titleFr }}</strong></i
        >
      </h6>
      <h6 class="opening-info-title" *ngIf="currentLang === 'en'">
        <i
          ><strong class="more-infos">{{ 'decking-boards.environment.most-infos' | translate }}</strong> -
          <strong>{{ opening.tooltip.titleEn }}</strong></i
        >
      </h6>
      <p class="terrain-info-description" *ngIf="currentLang === 'fr'">{{ opening.tooltip.descriptionFr }}</p>
      <p class="terrain-info-description" *ngIf="currentLang === 'en'">{{ opening.tooltip.descriptionEn }}</p>
    </div>

    <ng-casto-img-loader
      *ngIf="opening.tooltip.icon"
      [imgSrc]="baseImgURL + opening.tooltip.icon.path"
      [imgClass]="'location-info-image'"></ng-casto-img-loader>
  </div>
</div>

<br />

<div class="config-container shadow" *ngIf="areDimensionsValid() && configuration.openingSystem">
  <h4 class="title configurator-subtitle">
    {{ 'closet-doors-custom.closet-configuration.panel-configuration' | translate }}
  </h4>

  <div *ngIf="configuration.openingSystem?.type == OpeningSystemType.sliding">
    <div>
      <div class="form-row">
        <div class="form-label">
          <label for="has-plinth">{{ 'closet-doors-custom.closet-configuration.has-plinth' | translate }}</label>
        </div>
        <div class="form-switch">
          <span class="mr-2">{{ 'closet-doors-custom.closet-configuration.no' | translate }}</span>
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              id="has-plinth"
              [(ngModel)]="configuration.clientHasBaseboard"
              (click)="updateBaseboard()" />
            <label class="custom-control-label" for="has-plinth">{{
              'closet-doors-custom.closet-configuration.yes' | translate
            }}</label>
          </div>
        </div>
      </div>

      <div *ngIf="configuration.clientHasBaseboard">
        <div class="form-row">
          <div class="form-label">
            <label for="baseboard-qty">{{
              'closet-doors-custom.closet-configuration.baseboard-qty' | translate
            }}</label>
          </div>
          <div class="form-input">
            <div class="inputNumber">
              <input
                type="number"
                min="1"
                max="2"
                id="baseboard-qty"
                autocorrect="off"
                spellcheck="false"
                [(ngModel)]="configuration.baseboardQty" />
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label">
            <label for="baseboard-thickness">{{
              'closet-doors-custom.closet-configuration.baseboard-thickness' | translate
            }}</label>
          </div>
          <div class="form-input">
            <div class="inputNumber">
              <input
                type="number"
                min="1"
                max="100"
                id="baseboard-thickness"
                autocorrect="off"
                spellcheck="false"
                [(ngModel)]="configuration.baseboardThickness" />
            </div>
          </div>
        </div>
      </div>

      <h4 class="title configurator-subtitle">
        {{ 'closet-doors-custom.closet-configuration.opening-percent-and-panel' | translate }}
      </h4>
      <p class="custom-form-row form-checkbox">
        <span *ngFor="let openingPercent of configuration.openingSystem.openingSystemPercentages">
          <ul>
            <h4 class="title configurator-subtitle">&nbsp;{{ openingPercent.percentage }} %</h4>
            <div *ngFor="let number of openingPercent.nbDoor">
              &nbsp;
              <input
                type="radio"
                [checked]="
                  configuration.nbDoor === number && configuration.percentageOpening === openingPercent.percentage
                "
                [id]="openingPercent.percentage + number"
                name="door-number"
                (change)="
                  updateOpeningSystemPercentageAndPanel(openingPercent.percentage, number, openingPercent.nbWay)
                "
                [value]="number" />
              <label [for]="openingPercent.percentage + number"
                >{{ number }}
                {{
                  (number == 1
                    ? 'closet-doors-custom.closet-configuration.door'
                    : 'closet-doors-custom.closet-configuration.doors'
                  ) | translate
                }}</label
              >
            </div>
          </ul>
        </span>
      </p>
    </div>
  </div>

  <div *ngIf="configuration.openingSystem?.type != OpeningSystemType.sliding">
    <h4 class="title configurator-subtitle">
      {{ 'closet-doors-custom.closet-configuration.panel-number' | translate }}
    </h4>
    <p class="custom-form-row form-checkbox">
      <span *ngFor="let numDoor of getOpeningSystemSidesNbDoor()">
        <input
          type="radio"
          [checked]="configuration.nbDoor === numDoor"
          [id]="numDoor"
          name="door-number"
          (change)="configuration.nbDoor = numDoor; configuration.nbWay = 1"
          [value]="numDoor" />
        <label [for]="numDoor"
          >{{ numDoor }}
          {{
            (numDoor == 1
              ? 'closet-doors-custom.closet-configuration.door'
              : 'closet-doors-custom.closet-configuration.doors'
            ) | translate
          }}</label
        >
      </span>
    </p>

    <div
      *ngIf="
        configuration.openingSystem?.openingSystemSides != null &&
        configuration.openingSystem?.openingSystemSides.length > 0 &&
        configuration.nbDoor != null
      ">
      <h4 class="title configurator-subtitle">
        {{ 'closet-doors-custom.closet-configuration.opening-side' | translate }}
      </h4>
      <div class="configurator-cards-container">
        <div
          class="configurator-card"
          [ngClass]="{ active: isOpeningSideSelected(openingSide.id) }"
          *ngFor="let openingSide of availableOpeningSide(this.configuration.nbDoor)"
          (click)="selectOpeningSide(openingSide)">
          <ng-casto-img-loader
            [imgSrc]="baseImgURL + openingSide.icon.path"
            [imgClass]="'opening-img'"></ng-casto-img-loader>
          <p class="configurator-card-title">{{ openingSide.name }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
